export const all_routes = {
  // Auth Routes
  login: "/auth/login",
  register: "/auth/register",
  verificationOtp: "/auth/verification-otp",
  successMessage: "/auth/success-message",
  forgotPasssword: "/auth/forgot-password",
  confirmEmail: "/auth/confirm-email",
  resetPassword: "/auth/reset-password/:token?",

  acceptInvitation: "/auth/accept-invitation",

  emailPassword: "/auth/email-password",
  verifyAccount: "/auth/verification",
  userSetPassword: "/auth/user-set-password",

  // Register steps Routes
  stepOne: "/auth/stepOne",
  stepTwo: "/auth/stepTwo",
  thankYou: "/auth/thank-you",


  // dashboard
  dashboard: "/dashboard",

  // pricing plan
  pricing: "/pricing",
  paymentSuccess: "/payment-success",
  PaymentFailed: "/payment-failed",

  // User Routes
  profile: "/profile",
  profileChangePassword: "/profile/change-password",

  // Owner Routes
  manageUser: "/manage-user",
  addMember: "/manage-user/add-member",
  properties: "/properties",
  addProperties: "/properties/addproperties",
  editProperties: "/properties/addproperties/:id",
  logHours: "/log-hours",
  logHoursRequests: "/log-hours/requests",
  addLogHours: "/log-hours/add",
  logHoursDetails: "/log-hours/detail/:id",
  editLogHours: "/log-hours/add/:id",
  mileage: "/mileage",
  addMileage: "/mileage/add",
  editMileage: "/mileage/add/:id",
  auditTrail: "/audit-trail",
  reports: "/reports",
  generatedReports: "/reports/generated-reports",
  billingAndSubscription: "/billing-and-subscription",
  planList: "/plan-list",

  // Non Real Estate
  nonRealDashboard: "/nonRealEstate/dashboard",
  nonRealActivity: "/nonRealEstate/activity",
  nonRealLogHours: "/nonRealEstate/log-hours",
  nonRealReports: "/nonRealEstate/reports",
  nonRealGeneratedReports: "/nonRealEstate/reports/generated-reports",
  nonRealManageUser: "/nonRealEstate/manage-user",
  nonRealBillingAndSubscription: "/nonRealEstate/billing-and-subscription",

  NonRealhelpcenter: "/nonRealEstate/help-center",
  NonRealaddmember: "/nonRealEstate/manage-user/add-member",
  NonRealchatbot: "/nonRealEstate/chat-bot",

  // Spouse Pages
  spouseDashboard: "/spouse/dashboard",
  spouseProperties: "/spouse/properties",
  spousePropertiesDetail: "/spouse/properties/detail/:id",
  spouseMileage: "/spouse/mileage",
  addSpouseMileage: "/spouse/mileage/add",
  editSpouseMileage: "/spouse/mileage/add/:id",
  spouseLogHours: "/spouse/log-hours",
  addSpouseLogHours: "/spouse/log-hours/add",
  editSpouseLogHours: "/spouse/log-hours/add/:id",
  spouseLogHoursDetails: "/spouse/log-hours/detail/:id",
  spouseReports: "/spouse/reports",
  spouseGeneratedReports: "/spouse/reports/generated-reports",

  // tax professional Pages
  cpaDashboard: "/cpa/dashboard",
  cpaProperties: "/cpa/properties",
  cpaPropertiesDetail: "/cpa/properties/detail/:id",
  cpaLogHours: "/cpa/log-hours",
  cpaLogHoursDetails: "/cpa/log-hours/detail/:id",
  cpaMileage: "/cpa/mileage",
  cpaAuditTrail: "/cpa/audit-trail",
  cpaReports: "/cpa/reports",
  cpaGeneratedReports: "/cpa/reports/generated-reports",

  // common pages
  chatbot: "/chatbot",
  helpCenter: "/help-center",
  notifications: "/notifications",
  customerSupport: "/customer-support",


  //  CMS pages
  contactUs: "/contact-us",
  termsCondition: "/terms-condition",
  privacyPolicy: "/privacy-policy",
  faq: "/faq",
  aboutUs: "/about-us",
  blog: "/blog",
  blogDetails: "/blog-details/:uuid",
  cmsPricing: "/cms/pricing",

  comingSoon: "/pages/coming-soon",
  error404: "/pages/error-404",
  maintenance: "/pages/maintenance",
};
